import(/* webpackMode: "eager" */ "/app/src/app/[lang]/(unautorized)/error.tsx");
